import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { NgbTimepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'kt-timepicker',
	templateUrl: './timepicker.component.html',
	styleUrls: ['./timepicker.component.scss'],
	providers: [NgbTimepickerConfig],
})
export class TimepickerComponent implements OnInit {
	@Input() options: any = [];
	@Output() timeChange = new EventEmitter<any>(); // event when time change
	public time = {
		"hour": 0,
		"minute": 0,
		"second": 0
	  }
	constructor(config: NgbTimepickerConfig) {
		// customize default values of ratings used by this component tree
		config.seconds = true;
		config.spinners = false;
		config.meridian = true;
		config.size = "medium"
		config = { ...config, ...this.options };
	}

	onChange(event){
		if(!event){
			this.time = {
				"hour": 0,
				"minute": 0,
				"second": 0
			  }
			this.timeChange.emit(this.time);

		}
		else {
			this.timeChange.emit(event);
		}
	}

	ngOnInit() {}
}
